// Import constants
import { TERMS_OF_SERVICE_URL } from '../constants/links';

// Import components
import SeoHead from '../components/seo/SeoHead';
import StickyNavbar from '../components/navbar/StickyNavbar';

export default function TermsOfService() {
  return (
    <div className="w-full min-h-screen bg-white text-gray-800 flex flex-col">
      <SeoHead route="/terms" />
      <StickyNavbar />

      <main className="flex flex-col flex-1 py-4">
        <h1 className="sr-only">Terms of Service</h1>
        <iframe
          className="flex-1"
          src={TERMS_OF_SERVICE_URL}
          title="WhenWeMeet Terms of Service"
        />
      </main>
    </div>
  );
}
